import { jwtDecode } from 'jwt-decode';

const authTokenKey = "jwtToken";

export const isAuthenticated = () => {
    let result = false;
    let jwtToken = getToken();
    if (jwtToken !== null) {
        result = true;
    }

    return result;
}

export const setAuthenticated = (token) => {
    try {
        localStorage.setItem(authTokenKey, token);

        // 使用 jwt-decode 套件解析 JWT token
        const payload = jwtDecode(token);
        const expiration = payload.exp * 1000; // `exp` 是以秒为单位的，将其转换为毫秒

        localStorage.setItem("jwtExpiration", expiration);
        
        console.log('Token set successfully with jwt-decode', {
            exp: payload.exp,
            expirationTime: new Date(expiration).toISOString(),
            currentTime: new Date().toISOString(),
            timeUntilExpiry: Math.floor((expiration - Date.now()) / 1000 / 60) + ' minutes'
        });
    } catch (e) {
        console.error('Error parsing JWT token:', e);
    }
}

export const removeToken = () => {
    localStorage.removeItem(authTokenKey);
    localStorage.removeItem("jwtExpiration");
}

export const isTokenExpired = () => {
    const expiration = localStorage.getItem("jwtExpiration");

    if (!expiration) return true;

    const now = Date.now();
    return now > expiration;
};

export const getToken = () => {
    if (isTokenExpired()) {
        localStorage.removeItem(authTokenKey);
        localStorage.removeItem("jwtExpiration");
        return null;
    }
    return localStorage.getItem(authTokenKey);
};